import Modal from "../../../components/Modal";
import ModalWrapper from "../../../components/ModalWrapper";
import { Trans } from "@lingui/macro";
import { AutoColumn } from "../../../components/Column";
import { useCallback, useMemo, useEffect, useState } from "react";
import styled from "styled-components";
import NumericalInput from "../../../components/NumericalInput";
import AddressInput from "../../../components/AddressInput";
import Row from "../../../components/Row";
import useERC20Allowance from "../../../hooks/useERC20Allowance";
//import { MINI_POOL_ADDRESS } from "../../../constants/address";
import { CPNODES_ADDRESS } from "../../../constants/address";
import useERC20Approve from "../../../hooks/useERC20Approve";
import { useWallet } from "use-wallet";

import { ButtonLight, ButtonPrimary } from "../../../components/Button";
import Loader from "../../../components/Loader";
import useERC20Balance from "../../../hooks/useERC20Balance";
import { fromAmount, toAmount } from "../../../utils/amount";
import Big from "big.js";
import { ZERO_ADDRESS } from "../../../utils/ethereum";
const InputText = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const InputAddress = styled(AddressInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const LabelWrapper = styled.div`
  font-size: 14px;
`;

const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  font-size: 14px;
`;

function NodeUpdateModal({
  isOpen,
  setIsOpen,
  minPledge,
  nodeOpt,
  token,
  pkgitem,
}) {
  const { account, chainId } = useWallet();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");

  const [nodeAddr, setNodeAddr] = useState("");
  const [rewardAddr, setRewardAddr] = useState("");
  const [adminAddr, setAdminAddr] = useState("");
  const [appgroup, setAppgroup] = useState("");
  const [desc, setDesc] = useState("");

  const tokenContract = useMemo(() => {
    if (token) {
      return token.contract;
    }
    return null;
  }, [token]);

  const balance = useERC20Balance(tokenContract, account);
  const [allowance, fetchAllowance] = useERC20Allowance(
    tokenContract,
    account,
    CPNODES_ADDRESS[chainId]
  );

  const [onApprove, approveLoading] = useERC20Approve(
    tokenContract,
    CPNODES_ADDRESS[chainId]
  );

  useEffect(() => {
    setNodeAddr(pkgitem.nodeAddr);
    setRewardAddr(pkgitem.rewardAddr);
    setAppgroup(pkgitem.appgroup);
    setDesc(pkgitem.desc);
    setAdminAddr(pkgitem.adminAddr);
    

  }, [
    pkgitem
  ]);

 
  const handleOnDesc = useCallback(async () => {

    await nodeOpt.setNodeDesc(
      pkgitem.nodeid,
      desc,
      setLoading,
     
    );
    
  }, [desc]);

  const handleOnAppgroup = useCallback(async () => {

    await nodeOpt.changeAppGroup(
      pkgitem.nodeid,
      appgroup,
      0,
      setLoading,
     
    );
    
  }, [appgroup]);

  const handleOnNodeAddr = useCallback(async () => {

    await nodeOpt.transferNodeOwner(
      pkgitem.nodeid,
      nodeAddr,
      setLoading,
     
    );
    
  }, [nodeAddr]);




  const handleOnRewardAddr = useCallback(async () => {

    await nodeOpt.transferNodeReward(
      pkgitem.nodeid,
      rewardAddr,
      setLoading,
    );
    
  }, [rewardAddr]);


  const handleOnAdminAddr = useCallback(async () => {

    await nodeOpt.transferNodeAdmin(
      pkgitem.nodeid,
      adminAddr,
      setLoading,
    );
    
  }, [adminAddr]);

  return (
    <Modal isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
      <ModalWrapper
        title={<Trans>Update {pkgitem.desc} Node</Trans>}
        toggleWalletModal={() => setIsOpen(false)}
      >
        <AutoColumn gap={"24px"}>
          <AutoColumn gap={"sm"}>
            <LabelWrapper>
              <Trans>appgroup</Trans>
            </LabelWrapper>
            <InputAddress value={appgroup} onUserInput={setAppgroup} />

            <ButtonLight onClick={handleOnAppgroup} disabled={loading}>
              {loading && <Loader />} <Trans>Update App</Trans>
            </ButtonLight>
            <LabelWrapper>
              <Trans>Node Name</Trans>
            </LabelWrapper>
            <InputAddress value={desc} onUserInput={setDesc} />
            <ButtonLight onClick={handleOnDesc} disabled={loading}>
              {loading && <Loader />} <Trans>Update Name</Trans>
            </ButtonLight>
            <LabelWrapper>
              <Trans>Node Address</Trans>
            </LabelWrapper>
            <InputAddress value={nodeAddr} onUserInput={setNodeAddr} />
            <ButtonLight onClick={handleOnNodeAddr} disabled={loading}>
              {loading && <Loader />} <Trans>Update Node Addess</Trans>
            </ButtonLight>
            <LabelWrapper>
              <Trans>Reward Address</Trans>
            </LabelWrapper>
            <InputAddress value={rewardAddr} onUserInput={setRewardAddr} />
         
          <ButtonLight onClick={handleOnRewardAddr} disabled={loading}>
            {loading && <Loader />} <Trans>Transfer Reward Address</Trans>
          </ButtonLight>

          <LabelWrapper>
              <Trans>Admin Address</Trans>
            </LabelWrapper>
            <InputAddress value={adminAddr} onUserInput={setAdminAddr} />
          </AutoColumn>
          <ButtonLight onClick={handleOnRewardAddr} disabled={loading}>
            {loading && <Loader />} <Trans>Transfer Admin Address</Trans>
          </ButtonLight>

        </AutoColumn>
      </ModalWrapper>
    </Modal>
  );
}

export default NodeUpdateModal;
